<template>
    <div class="login">
      <h1>Sign in</h1>
      <input type="text" v-model="email" @keyup.enter="login" placeholder="email"><br>
      <input type="password" v-model="password" @keyup.enter="login" placeholder="Password"><br>
      <button id="sign-in-button" @keyup.enter="login" @click="login">Login</button>
      <p>Don't have an account? <router-link to="/sign-up">Create one.</router-link></p>
    </div>
</template>

<script>
  import firebase from 'firebase';

  export default {
        name: "Login",
        data() {
          return{};
        },
        methods: {
          login: function () {
            firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
              (user) => {
                this.$router.replace('admin')
              },
              (err) => {
                alert('Oops. ' + err.message)
              }
            )

          }
        }

    }
</script>

<style scoped>
  .login {
    margin-top: 40px;
  }
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 10%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue